import { NoticeAccent } from "./NoticeAccent";
import { NoticeFilled } from "./NoticeFilled";
import { NoticeTopBar } from "./NoticeTopBar";
import {
  type AccentNoticeProps,
  type NoticeProps,
  type TopBarNoticeProps,
} from "./types";

export { NoticeType } from "./noticeConfig";

const isAccentNotice = (notice: NoticeProps): notice is AccentNoticeProps =>
  notice.variant === "accent";

const isTopBarNotice = (notice: NoticeProps): notice is TopBarNoticeProps =>
  notice.variant === "topBar";

export const Notice = (props: NoticeProps) => {
  if (isAccentNotice(props)) {
    return <NoticeAccent {...props} />;
  }

  if (isTopBarNotice(props)) {
    return <NoticeTopBar {...props} />;
  }

  return <NoticeFilled {...props} />;
};
